/**
 * Voegt het gratis-cadeau-product automatisch toe aan/verwijdert het uit de
 * winkelwagen op basis van de bestelwaarde. De korting die het product
 * daadwerkelijk gratis maakt komt uit een Shopify "Koop X, krijg Y" korting
 * (Shopify Kortingen) — dit script zorgt alleen dat het product op tijd in
 * de cart terechtkomt.
 *
 * Config wordt gezet door theme.liquid via window.cartFreeGift.
 *
 * Na een wijziging publiceren we PUB_SUB_EVENTS.cartUpdate: cart-items.js
 * ververst zowel de cart-pagina (<cart-items>) als de cart-drawer
 * (<cart-drawer-items>) daar zelf al automatisch op (zie CartItems.onCartUpdate
 * in cart.js) — dat hoeven we dus niet zelf te doen. Alleen de cart-bubble
 * wordt daar niet door geraakt, dus die verversen we hier apart.
 */
(function () {
  var isSyncing = false;

  function getConfig() {
    return window.cartFreeGift;
  }

  function getCart() {
    return fetch('/cart.js').then(function (response) {
      return response.json();
    });
  }

  function addGift(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { _gift: 'true' } }],
      }),
    });
  }

  function removeGift(line) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 }),
    });
  }

  function refreshCartBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return Promise.resolve();

    return fetch('/?sections=cart-icon-bubble')
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (!data['cart-icon-bubble']) return;
        var parsed = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
        var newBubble = parsed.getElementById('cart-icon-bubble');
        if (newBubble) bubble.innerHTML = newBubble.innerHTML;
      });
  }

  function notifyCartUpdated() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-free-gift' });
    }
    return refreshCartBubble();
  }

  function syncGift() {
    var config = getConfig();
    if (!config || !config.active || !config.variantId || isSyncing) return;

    isSyncing = true;

    getCart()
      .then(function (cart) {
        var giftLine = null;
        var subtotalWithoutGift = 0;

        cart.items.forEach(function (item, index) {
          if (item.variant_id === config.variantId) {
            giftLine = index + 1;
          } else {
            subtotalWithoutGift += item.final_line_price;
          }
        });

        var qualifies = subtotalWithoutGift >= config.threshold;

        if (qualifies && !giftLine && config.available) {
          return addGift(config.variantId).then(notifyCartUpdated);
        }

        if (!qualifies && giftLine) {
          return removeGift(giftLine).then(notifyCartUpdated);
        }
      })
      .catch(function (error) {
        console.error('[cart-free-gift]', error);
      })
      .finally(function () {
        isSyncing = false;
      });
  }

  document.addEventListener('DOMContentLoaded', syncGift);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'cart-free-gift') return;
      setTimeout(syncGift, 300);
    });
  }
})();
